import Image from "@components/common/Image";
import styles from "./Author.module.scss";
import { formatDateDisplay } from "@utils/dateFormatter";
const View = ({ image, name, createdAt, updatedAt, publishedAt }: any) => {
  return (
    <div className={styles.author}>
      <Image
        animated={false}
        wrapperProps={{ className: styles.avatar }}
        width={46}
        height={46}
        layout=""
        {...image}
      />
      <div className="ml-3">
        <div className={styles.name}>{name}</div>
        <div className={styles.posted}>
          Đăng ngày {formatDateDisplay(publishedAt)}
        </div>
      </div>
    </div>
  );
};
export default View;
